import { useState } from "react";
import { Search, Users, Lock, Globe, Star, ChevronDown, Calendar, MapPin, Music, Code, Dumbbell, Palette, Gamepad2, Camera, X, Clock, FileText, CheckCircle2, AlertCircle } from "lucide-react";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { useToast } from "../../hooks/use-toast";
















const categories = ["All", "Technology", "Music", "Sports", "Art", "Gaming", "Photography"];

const categoryIcons = {
  Technology: Code,
  Music: Music,
  Sports: Dumbbell,
  Art: Palette,
  Gaming: Gamepad2,
  Photography: Camera
};

const universities = ["All Universities", "ADA University", "Baku State University", "Baku Engineering University", "Khazar University", "ASOIU"];

const allClubs = [
{ id: 1, name: "Robotics Club", university: "ADA University", category: "Technology", members: 24, bio: "Building robots and competing in international robotics competitions. Weekly workshops and hackathons.", isPrivate: false, initials: "RC", rating: 4.8, events: [
  { title: "Robot Wars Competition", date: "Mar 15, 2026", deadline: "Mar 10, 2026", location: "ADA Campus", attendees: 45, description: "Annual robot battle competition where teams build and program robots to compete in obstacle courses and head-to-head matches. Prize pool: 2000 AZN.", requirements: ["Team of 2-4 members", "Basic Arduino knowledge", "Bring your own robot kit"], maxParticipants: 60 },
  { title: "Arduino Workshop", date: "Mar 22, 2026", deadline: "Mar 20, 2026", location: "Lab 201", attendees: 20, description: "Hands-on workshop covering Arduino basics, sensor integration, and motor control. All materials provided.", requirements: ["Laptop required"], maxParticipants: 25 }]
},
{ id: 2, name: "Music & Jam Sessions", university: "Baku State University", category: "Music", members: 38, bio: "Weekly jam sessions, open mic nights, and music production workshops for all skill levels.", isPrivate: false, initials: "MJ", rating: 4.6, events: [
  { title: "Open Mic Night", date: "Mar 18, 2026", deadline: "Mar 17, 2026", location: "Student Center", attendees: 60, description: "Perform your original songs or covers in a supportive environment. All genres and instruments welcome. Free drinks for performers!", maxParticipants: 80 }]
},
{ id: 3, name: "Competitive Programming", university: "ADA University", category: "Technology", members: 52, bio: "Preparing for ACM ICPC and Codeforces contests. Daily practice and algorithm lectures.", isPrivate: true, initials: "CP", rating: 4.9, events: [
  { title: "Mock ICPC Contest", date: "Mar 20, 2026", deadline: "Mar 18, 2026", location: "CS Lab", attendees: 30, description: "Simulate a real ACM ICPC regional contest with 10 problems in 5 hours. Teams of 3. Prizes for top 3 teams.", requirements: ["Team of exactly 3", "Codeforces rating 1200+", "Bring student ID"], maxParticipants: 45 },
  { title: "Algorithm Masterclass", date: "Mar 25, 2026", deadline: "Mar 24, 2026", location: "Online (Zoom)", attendees: 80, description: "Deep dive into dynamic programming and graph algorithms with Prof. Aliyev. Recording available after.", maxParticipants: 150 }]
},
{ id: 4, name: "Fitness & Gym Club", university: "Baku Engineering University", category: "Sports", members: 65, bio: "Group workouts, nutrition plans, and fitness challenges. Beginners welcome!", isPrivate: false, initials: "FG", rating: 4.5, events: [
  { title: "Spring Fitness Challenge", date: "Mar 10-31, 2026", deadline: "Mar 8, 2026", location: "University Gym", attendees: 40, description: "30-day fitness challenge with daily workouts, nutrition tracking, and weekly progress check-ins. Prizes for most improved.", requirements: ["Medical clearance form", "Gym membership or day pass"], maxParticipants: 50 }]
},
{ id: 5, name: "Digital Art Society", university: "Khazar University", category: "Art", members: 19, bio: "Digital illustration, 3D modeling, and animation workshops using industry tools.", isPrivate: false, initials: "DA", rating: 4.7, events: [] },
{ id: 6, name: "E-Sports Club", university: "ASOIU", category: "Gaming", members: 88, bio: "Competitive gaming in Valorant, CS2, and League of Legends. Regular tournaments and scrims.", isPrivate: false, initials: "ES", rating: 4.4, events: [
  { title: "Valorant Tournament", date: "Mar 28, 2026", deadline: "Mar 25, 2026", location: "Gaming Room", attendees: 32, description: "5v5 elimination tournament. Solo queue — teams formed randomly. Prize: Gaming peripherals + bragging rights.", requirements: ["Valorant account (any rank)", "Discord required for comms"], maxParticipants: 40 }]
},
{ id: 7, name: "Photography Club", university: "ADA University", category: "Photography", members: 27, bio: "Photo walks, editing workshops, and exhibitions. All camera types welcome.", isPrivate: true, initials: "PC", rating: 4.6, events: [
  { title: "Old City Photo Walk", date: "Mar 16, 2026", deadline: "Mar 14, 2026", location: "Icherisheher", attendees: 15, description: "Guided photo walk through Baku's historic Old City. Learn street photography techniques, composition, and storytelling through images.", requirements: ["Any camera (phone OK)", "Comfortable walking shoes"], maxParticipants: 20 }]
}];


// Mock saved application data
const savedApplication = {
  fullName: "Ali Aliyev",
  email: "ali.aliyev@ada.edu.az",
  phone: "+994 50 123 4567",
  university: "ADA University",
  major: "Computer Science",
  year: "3rd Year"
};

const ClubsDiscovery = ({ onOpenClub }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUni, setSelectedUni] = useState("All Universities");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchMode, setSearchMode] = useState("clubs");
  const [clubRoles, setClubRoles] = useState({
    1: { "You": "admin", "Rashad H.": "member", "Nigar S.": "moderator" }
  });
  const [joinedClubs, setJoinedClubs] = useState([1]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [useLastApplication, setUseLastApplication] = useState(true);
  const [applied, setApplied] = useState([]);
  const { toast } = useToast();

  const filtered = allClubs.filter((c) => {
    const matchesUni = selectedUni === "All Universities" || c.university === selectedUni;
    const matchesCategory = selectedCategory === "All" || c.category === selectedCategory;
    if (searchMode === "events") {
      const matchesEvent = c.events.some((e) => e.title.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchesUni && matchesCategory && (searchQuery.length < 2 || matchesEvent);
    }
    const matchesSearch = c.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearch && matchesUni && matchesCategory;
  });

  const allEvents = allClubs.flatMap((club) =>
  club.events.map((e) => ({ ...e, clubName: club.name, clubId: club.id, clubInitials: club.initials }))
  ).filter((e) => searchQuery.length < 2 || e.title.toLowerCase().includes(searchQuery.toLowerCase()));

  const filteredEvents = allEvents.filter((e) => {
    const club = allClubs.find((c) => c.id === e.clubId);
    const matchesUni = selectedUni === "All Universities" || club?.university === selectedUni;
    const matchesCategory = selectedCategory === "All" || club?.category === selectedCategory;
    return matchesUni && matchesCategory;
  });

  const handleJoin = (club) => {
    if (joinedClubs.includes(club.id)) return;
    if (club.isPrivate) {
      setPendingRequests((prev) => [...prev, club.id]);
      toast({ title: "Join request sent", description: `Your request to join "${club.name}" is pending admin approval.` });
    } else {
      setJoinedClubs((prev) => [...prev, club.id]);
      toast({ title: "Joined!", description: `You are now a member of "${club.name}".` });
    }
  };

  const handleApply = (eventTitle) => {
    setApplied((prev) => [...prev, eventTitle]);
    toast({ title: "Application submitted!", description: `You've applied for "${eventTitle}".` });
    setSelectedEvent(null);
  };

  const getStatus = (id) => {
    if (joinedClubs.includes(id)) return "joined";
    if (pendingRequests.includes(id)) return "pending";
    return "none";
  };

  return (
    <div className="space-y-4">
      {/* Search & Filters */}
      <div className="stat-card !p-4 space-y-3">
        <div className="flex gap-1 p-1 rounded-xl bg-muted w-fit">
          <button onClick={() => setSearchMode("clubs")}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${searchMode === "clubs" ? "bg-card text-foreground shadow-sm" : "text-muted-foreground"}`}>
            Search Clubs
          </button>
          <button onClick={() => setSearchMode("events")}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${searchMode === "events" ? "bg-card text-foreground shadow-sm" : "text-muted-foreground"}`}>
            Find Events
          </button>
          <button onClick={() => setSearchMode("my")}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${searchMode === "my" ? "bg-card text-foreground shadow-sm" : "text-muted-foreground"}`}>
            My Clubs
          </button>
        </div>

        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <input value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={searchMode === "clubs" ? "Search clubs by name..." : "Search events..."}
          className="w-full pl-10 pr-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
          
        </div>

        <div className="flex flex-wrap gap-2">
          <div className="relative">
            <select value={selectedUni} onChange={(e) => setSelectedUni(e.target.value)}
            className="appearance-none pl-3 pr-8 py-2 rounded-xl bg-muted text-xs font-medium text-foreground cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring">
              {universities.map((u) => <option key={u} value={u}>{u}</option>)}
            </select>
            <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 w-3 h-3 text-muted-foreground pointer-events-none" />
          </div>
        </div>

        <div className="flex flex-wrap gap-1.5">
          {categories.map((cat) => {
            const Icon = categoryIcons[cat];
            return (
              <button key={cat} onClick={() => setSelectedCategory(cat)}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-xl text-xs font-medium transition-colors ${
              selectedCategory === cat ? "bg-secondary/15 text-secondary" : "bg-muted text-muted-foreground hover:text-foreground"}`
              }>
                {Icon && <Icon className="w-3 h-3" />}
                {cat}
              </button>);

          })}
        </div>

        <p className="text-xs text-muted-foreground">
          {searchMode === "clubs" ? `${filtered.length} club${filtered.length !== 1 ? "s" : ""} found` : `${filteredEvents.length} event${filteredEvents.length !== 1 ? "s" : ""} found`}
        </p>
      </div>

      {/* Events view */}
      {searchMode === "events" ?
      <div className="space-y-3">
          {filteredEvents.length === 0 ?
        <div className="stat-card !p-8 text-center">
              <Calendar className="w-10 h-10 text-muted-foreground/20 mx-auto mb-3" />
              <p className="text-sm font-medium text-muted-foreground">No events found</p>
            </div> :

        filteredEvents.map((event, i) =>
        <button key={i} onClick={() => setSelectedEvent(event)}
        className="w-full stat-card !p-4 flex items-start gap-3 text-left hover:border-secondary/30 transition-colors">
                <div className="w-12 h-12 rounded-xl bg-secondary/10 flex flex-col items-center justify-center flex-shrink-0">
                  <Calendar className="w-4 h-4 text-secondary mb-0.5" />
                  <span className="text-[9px] font-bold text-secondary">{event.date.split(",")[0].split(" ").slice(0, 2).join(" ")}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-display font-bold text-foreground">{event.title}</h4>
                  <p className="text-xs text-muted-foreground mt-0.5 flex items-center gap-1.5">
                    <span className="px-1.5 py-0.5 rounded-md bg-primary/10 text-primary font-medium">{event.clubName}</span>
                    <span className="flex items-center gap-0.5"><MapPin className="w-3 h-3" />{event.location}</span>
                  </p>
                  <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground">
                    <span>{event.attendees}{event.maxParticipants ? `/${event.maxParticipants}` : ""} attending</span>
                    <span className="flex items-center gap-0.5"><Clock className="w-3 h-3" /> Deadline: {event.deadline}</span>
                    {event.requirements && event.requirements.length > 0 &&
              <span className="flex items-center gap-0.5 text-chart-5"><AlertCircle className="w-3 h-3" /> {event.requirements.length} req.</span>
              }
                  </div>
                </div>
                {applied.includes(event.title) ?
          <span className="px-3 py-1.5 rounded-xl bg-secondary text-secondary-foreground text-xs font-semibold flex-shrink-0 flex items-center gap-1">
                    <CheckCircle2 className="w-3 h-3" /> Applied
                  </span> :

          <span className="px-3 py-1.5 rounded-xl bg-primary text-primary-foreground text-xs font-semibold flex-shrink-0">
                    View & Apply
                  </span>
          }
              </button>
        )
        }
        </div> : (

      /* Clubs grid */
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {filtered.map((club) => {
          const status = getStatus(club.id);
          const CatIcon = categoryIcons[club.category];
          return (
            <div key={club.id} className="stat-card !p-4 flex flex-col">
                <div className="flex items-start gap-3 mb-2">
                  <Avatar className="w-11 h-11 flex-shrink-0">
                    <AvatarFallback className="bg-primary/10 text-primary text-sm font-bold">{club.initials}</AvatarFallback>
                  </Avatar>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5">
                      <button onClick={() => onOpenClub?.(club.id)}
                    className="text-sm font-display font-bold text-foreground hover:text-secondary transition-colors truncate">
                        {club.name}
                      </button>
                      {club.isPrivate ? <Lock className="w-3 h-3 text-muted-foreground flex-shrink-0" /> : <Globe className="w-3 h-3 text-muted-foreground flex-shrink-0" />}
                    </div>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      <span className="px-1.5 py-0.5 rounded-md bg-primary/10 text-primary font-medium">{club.university}</span>
                      <span className="mx-1">·</span>
                      {CatIcon && <CatIcon className="w-3 h-3 inline mr-0.5" />}
                      {club.category}
                    </p>
                  </div>
                </div>

                <p className="text-xs text-muted-foreground leading-relaxed line-clamp-2 mb-2 flex-1">{club.bio}</p>

                {club.events.length > 0 &&
              <div className="mb-3 space-y-1.5">
                    {club.events.slice(0, 2).map((event, i) =>
                <button key={i} onClick={() => setSelectedEvent({ ...event, clubName: club.name, clubId: club.id, clubInitials: club.initials })}
                className="w-full flex items-center gap-2 p-2 rounded-lg bg-muted/50 text-xs hover:bg-muted transition-colors">
                        <Calendar className="w-3 h-3 text-secondary flex-shrink-0" />
                        <span className="font-medium text-foreground truncate flex-1">{event.title}</span>
                        <span className="text-muted-foreground text-[10px] flex-shrink-0">{event.date.split(",")[0]}</span>
                      </button>
                )}
                  </div>
              }

                <div className="flex items-center gap-3 text-xs text-muted-foreground mb-3">
                  <span className="flex items-center gap-1"><Users className="w-3 h-3" /> {club.members}</span>
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {club.events.length} events</span>
                  <span className="flex items-center gap-0.5 ml-auto"><Star className="w-3 h-3 text-chart-4 fill-chart-4" /> {club.rating}</span>
                </div>

                <div className="flex gap-2">
                  <button onClick={() => onOpenClub?.(club.id)}
                className="flex-1 h-8 rounded-xl bg-muted text-xs font-medium text-foreground hover:bg-muted/80 transition-colors">
                    View
                  </button>
                  {status === "joined" ?
                <button className="flex-1 h-8 rounded-xl bg-secondary text-secondary-foreground text-xs font-semibold cursor-default">✓ Joined</button> :
                status === "pending" ?
                <button className="flex-1 h-8 rounded-xl bg-chart-5/15 text-chart-5 text-xs font-semibold cursor-default">⏳ Pending</button> :

                <button onClick={() => handleJoin(club)}
                className="flex-1 h-8 rounded-xl bg-primary text-primary-foreground text-xs font-semibold hover:bg-primary/90 transition-colors flex items-center justify-center gap-1">
                      {club.isPrivate ? <><Lock className="w-3 h-3" /> Request</> : "Join"}
                    </button>
                }
                </div>
              </div>);

        })}
        </div>)
      }

      {/* My Clubs View */}
      {searchMode === "my" &&
      <div className="space-y-3">
          {(() => {
          const myClubs = allClubs.filter((c) => joinedClubs.includes(c.id));
          const filteredMyClubs = myClubs.filter((c) => c.name.toLowerCase().includes(searchQuery.toLowerCase()));
          if (filteredMyClubs.length === 0) return (
            <div className="stat-card !p-8 text-center">
                <Users className="w-10 h-10 text-muted-foreground/20 mx-auto mb-3" />
                <p className="text-sm font-medium text-muted-foreground">You haven't joined any clubs yet</p>
              </div>);

          return filteredMyClubs.map((club) => {
            const role = clubRoles[club.id]?.["You"] || "member";
            const members = clubRoles[club.id] || {};
            return (
              <div key={club.id} className="stat-card !p-4">
                  <div className="flex items-start gap-3 mb-2">
                    <Avatar className="w-11 h-11 flex-shrink-0">
                      <AvatarFallback className="bg-primary/10 text-primary text-sm font-bold">{club.initials}</AvatarFallback>
                    </Avatar>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-1.5">
                        <span className="text-sm font-display font-bold text-foreground truncate">{club.name}</span>
                        <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-bold uppercase ${
                      role === "admin" ? "bg-chart-4/15 text-chart-4" : role === "moderator" ? "bg-secondary/15 text-secondary" : "bg-muted text-muted-foreground"}`
                      }>{role}</span>
                      </div>
                      <p className="text-xs text-muted-foreground mt-0.5">{club.university} · {club.category} · {club.members} members</p>
                    </div>
                  </div>
                  {role === "admin" && Object.keys(members).length > 1 &&
                <div className="mt-2 pt-2 border-t border-border">
                      <p className="text-[10px] uppercase tracking-wider font-bold text-muted-foreground mb-1.5">Members & Roles</p>
                      <div className="space-y-1">
                        {Object.entries(members).filter(([name]) => name !== "You").map(([name, memberRole]) =>
                    <div key={name} className="flex items-center justify-between px-2 py-1.5 rounded-lg bg-muted/50 text-xs">
                            <span className="text-foreground font-medium">{name}</span>
                            <select value={memberRole}
                      onChange={(e) => {
                        setClubRoles((prev) => ({ ...prev, [club.id]: { ...prev[club.id], [name]: e.target.value } }));
                        toast({ title: "Role updated", description: `${name} is now ${e.target.value}.` });
                      }}
                      className="appearance-none bg-transparent text-[10px] font-medium text-muted-foreground cursor-pointer focus:outline-none">
                              <option value="member">Member</option>
                              <option value="moderator">Moderator</option>
                              <option value="admin">Admin</option>
                            </select>
                          </div>
                    )}
                      </div>
                    </div>
                }
                </div>);

          });
        })()}
        </div>
      }

      {searchMode === "clubs" && filtered.length === 0 &&
      <div className="stat-card !p-8 text-center">
          <Users className="w-10 h-10 text-muted-foreground/20 mx-auto mb-3" />
          <p className="text-sm font-medium text-muted-foreground">No clubs found</p>
        </div>
      }

      {/* Event Detail Modal */}
      {selectedEvent &&
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setSelectedEvent(null)}>
          <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" />
          <div className="relative bg-card rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fade-in max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-border sticky top-0 bg-card z-10">
              <h3 className="font-display font-bold text-foreground flex items-center gap-2">
                <Calendar className="w-4 h-4 text-secondary" />
                Event Details
              </h3>
              <button onClick={() => setSelectedEvent(null)} className="w-8 h-8 rounded-xl hover:bg-muted flex items-center justify-center transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="p-5 space-y-4">
              {/* Event info */}
              <div>
                <h2 className="text-lg font-display font-bold text-foreground">{selectedEvent.title}</h2>
                <p className="text-xs text-muted-foreground mt-1 flex items-center gap-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary/10 text-primary font-medium">{selectedEvent.clubName}</span>
                </p>
              </div>

              <p className="text-sm text-muted-foreground leading-relaxed">{selectedEvent.description}</p>

              {/* Details grid */}
              <div className="grid grid-cols-2 gap-3">
                <div className="p-3 rounded-xl bg-muted/50">
                  <p className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">Date</p>
                  <p className="text-sm font-medium text-foreground flex items-center gap-1.5">
                    <Calendar className="w-3.5 h-3.5 text-secondary" /> {selectedEvent.date}
                  </p>
                </div>
                <div className="p-3 rounded-xl bg-muted/50">
                  <p className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">Location</p>
                  <p className="text-sm font-medium text-foreground flex items-center gap-1.5">
                    <MapPin className="w-3.5 h-3.5 text-secondary" /> {selectedEvent.location}
                  </p>
                </div>
                <div className="p-3 rounded-xl bg-destructive/5">
                  <p className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">Application Deadline</p>
                  <p className="text-sm font-medium text-destructive flex items-center gap-1.5">
                    <Clock className="w-3.5 h-3.5" /> {selectedEvent.deadline}
                  </p>
                </div>
                <div className="p-3 rounded-xl bg-muted/50">
                  <p className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">Participants</p>
                  <p className="text-sm font-medium text-foreground flex items-center gap-1.5">
                    <Users className="w-3.5 h-3.5 text-secondary" /> {selectedEvent.attendees}{selectedEvent.maxParticipants ? ` / ${selectedEvent.maxParticipants}` : ""}
                  </p>
                </div>
              </div>

              {/* Requirements */}
              {selectedEvent.requirements && selectedEvent.requirements.length > 0 &&
            <div>
                  <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-2 flex items-center gap-1.5">
                    <FileText className="w-3.5 h-3.5 text-chart-5" /> Requirements
                  </h4>
                  <div className="space-y-1.5">
                    {selectedEvent.requirements.map((req, i) =>
                <div key={i} className="flex items-start gap-2 p-2 rounded-lg bg-chart-5/5 text-xs">
                        <AlertCircle className="w-3.5 h-3.5 text-chart-5 mt-0.5 flex-shrink-0" />
                        <span className="text-foreground">{req}</span>
                      </div>
                )}
                  </div>
                </div>
            }

              {/* Apply section */}
              {applied.includes(selectedEvent.title) ?
            <div className="p-4 rounded-xl bg-secondary/10 text-center">
                  <CheckCircle2 className="w-6 h-6 text-secondary mx-auto mb-2" />
                  <p className="text-sm font-semibold text-secondary">You've already applied!</p>
                  <p className="text-xs text-muted-foreground mt-1">We'll notify you when your application is reviewed.</p>
                </div> :

            <div className="space-y-3 border-t border-border pt-4">
                  <h4 className="text-xs font-bold text-foreground uppercase tracking-wider">Apply</h4>

                  {/* Use last application toggle */}
                  <button onClick={() => setUseLastApplication(!useLastApplication)}
              className={`w-full flex items-center gap-3 p-3 rounded-xl text-left transition-colors ${
              useLastApplication ? "bg-secondary/10 border border-secondary/30" : "bg-muted border border-transparent"}`
              }>
                    <div className={`w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0 ${
                useLastApplication ? "bg-secondary text-secondary-foreground" : "bg-muted-foreground/20"}`
                }>
                      {useLastApplication && <CheckCircle2 className="w-3.5 h-3.5" />}
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground">Use my last application</p>
                      <p className="text-[10px] text-muted-foreground">{savedApplication.fullName} · {savedApplication.university} · {savedApplication.major}</p>
                    </div>
                  </button>

                  {!useLastApplication &&
              <div className="space-y-2">
                      <input defaultValue={savedApplication.fullName} placeholder="Full Name"
                className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
                      <input defaultValue={savedApplication.email} placeholder="Email"
                className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
                      <input defaultValue={savedApplication.phone} placeholder="Phone"
                className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
                      <input defaultValue={savedApplication.university} placeholder="University"
                className="w-full px-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
                    </div>
              }

                  <button onClick={() => handleApply(selectedEvent.title)}
              className="w-full h-10 rounded-2xl bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors">
                    Submit Application
                  </button>
                </div>
            }
            </div>
          </div>
        </div>
      }
    </div>);

};

export default ClubsDiscovery;